// extracted by mini-css-extract-plugin
module.exports = {"phone":"phone-input_phone__9MNAl","default":"phone-input_default__m5g4R","error":"phone-input_error__orITW","phone-small":"phone-input_phone-small__uFL1C"};